/**
 * Created by sagardesai on 28/06/18.
 */

import {RSAA} from 'redux-api-middleware';
import {API_ENDPOINT, API_ENDPOINT_V2, AUTH_HEADERS} from "../util/constants";
import * as types from "../actions/types/index";
import {handleUnauthorizedAccess} from "../util/utility";


export function getBroadcasterDetail(token, api_token, broadcaster_id) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/get-broadcaster-detail/${broadcaster_id}?api_token=${api_token}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.BROADCASTER_DETAIL_REQUEST, types.BROADCASTER_DETAIL_RECEIVE, {
                type: types.BROADCASTER_DETAIL_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export function getBroadcastDetail(token, api_token, broadcast_id) {
    
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/broadcast/${broadcast_id}?api_token=${api_token}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.BROADCAST_DETAIL_REQUEST, types.BROADCAST_DETAIL_RECEIVE, {
                type: types.BROADCAST_DETAIL_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}
export function getBroadcastDetailGuest(token, api_token, broadcast_id) {
    
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT_V2}/broadcast/${broadcast_id}`,
            method: 'GET',
            headers: {
                Accept:'application/vnd.vuepay.v2+json',...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.BROADCAST_DETAIL_REQUEST, types.BROADCAST_DETAIL_RECEIVE, {
                type: types.BROADCAST_DETAIL_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export function getListOfSimilarBroadcasters(token, api_token, data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/get-similar-broadcasters?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
            types: [types.SIMILAR_BROADCASTER_REQUEST, types.SIMILAR_BROADCASTER_RECEIVE, {
                type: types.SIMILAR_BROADCASTER_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}


export function getListOfTrendingBroadcasters(token, api_token, query, filter_by, page = 1) {

    let _filter_by = filter_by === "search" || filter_by === null ? "" : filter_by;
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/broadcast?api_token=${api_token}&query=${query}&filter_by=${_filter_by}&page=${page}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.TRENDING_BROADCASTERS_LIST_REQUEST, types.TRENDING_BROADCASTERS_LIST_RECEIVE, {
                type: types.TRENDING_BROADCASTERS_LIST_RECEIVE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export function getGuestListOfTrendingBroadcastersGuest(token, api_token, query, filter_by, page) {

    let _filter_by = filter_by === "search" || filter_by === null ? "" : filter_by;
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT_V2}/broadcast?query=${query}&filter_by=${_filter_by}&page=${page}`,
        // /broadcast?&query=search&filter_by=popularity
            method: 'GET',
            headers: {
                Accept:'application/vnd.vuepay.v2+json',...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.TRENDING_BROADCASTERS_LIST_REQUEST, types.TRENDING_BROADCASTERS_LIST_RECEIVE, {
                type: types.TRENDING_BROADCASTERS_LIST_RECEIVE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }

    
}

export const resetBroadcasterDetail = () => ({
    type: types.RESET_BROADCASTER_DETAIL,
    payload: null
});


export const resetBroadcastDetail = () => ({
    type: types.RESET_BROADCAST_DETAIL,
    payload: null
});

export const sortBroadcastBy = (sort_by) => ({
    type: types.BROADCASTS_LIST_SORT_BY,
    payload: sort_by
});

export const resetSortBroadcast = () => ({
    type: types.RESET_BROADCASTS_LIST_SORT_BY,
    payload: null
});

export const setSearchForBroadcasterState = (state) => ({
    type: types.SET_SEARCH_FOR_BROADCASTER_STATE,
    payload: state
});
